<form [formGroup]="mfaForm">
  <div class="form-groups margin-top-20">
    <div class="form-group margin-top-10">
      <p class="verification-sent-text">
        {{ translationService.getVerificationCodeSentText() }}
      </p>
      <mat-form-field appearance="outline">
        <mat-label>{{
          translationService.getVerificationCodeText()
        }}</mat-label>
        <input matInput type="text" name="code" formControlName="code" />
      </mat-form-field>
    </div>
  </div>
  <div class="actions margin-top-10">
    <button
      mat-raised-button
      extended
      color="primary"
      class="action-item"
      (click)="submit()"
    >
      <mat-icon>verified</mat-icon>
      {{ translationService.getVerifyText() }}
    </button>
    <span
      class="resend-code action-item"
      role="button"
      tabindex="0"
      (click)="resendCode()"
      (keydown.enter)="resendCode()"
      (keydown.space)="resendCode()"
    >
      {{ translationService.getResendCodeText() }}
    </span>
  </div>
</form>
